import React from 'react';
import emojiIconMap, { EMOJI_ICON_KEY_PREFIX } from '@/pages/Web/Outside/pages/Simulation/Pages/components/Evaluation/emojiMap';
import s from '../style.module.scss';

// 档位表情渲染（H5 版）：题库 options[].emoji 为图标 key（emoji_N）时渲染对应图片，否则按 unicode 文本回退
// 图片映射与素材与 PC 共用（emojiMap.js）
const OptionEmoji = ({ emoji }) => {
    if (typeof emoji === 'string' && emoji.startsWith(EMOJI_ICON_KEY_PREFIX) && emojiIconMap[emoji]) {
        return <img className={s['option-emoji']} src={emojiIconMap[emoji]} alt="" />;
    }
    return <span className={s['option-emoji']}>{emoji}</span>;
};

export default OptionEmoji;
